import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core'; // , AfterViewInit,

import { NgForm } from '@angular/forms';

import { Street } from '../street';
import { ContentService } from '../content.service';

import { Step1CalcComponent } from '../step1-calc/step1-calc.component';
import { Step2Data } from './step2-DataModel';

import { CompleterService, CompleterData } from 'ng2-completer';

import { AutoCompleterComponent } from '../auto-completer/auto-completer.component';

@Component({
  selector: 'app-step2-calc',
  templateUrl: './step2-calc.component.html',
  styleUrls: ['./step2-calc.component.css']
})
export class Step2CalcComponent implements OnInit, AfterViewInit { // , AfterViewInit

	constructor(private _contentService: ContentService,
		public step1Clac: Step1CalcComponent,
		private completerService: CompleterService) { }

    isCaptchaMissingProperty: boolean = true;    

	errorMessage: string;

	submitted = false;
	responseReceived = false;
	isStep2Eligible?: boolean;
	isReCaptchaOk: boolean;

	form: NgForm = null;

	loadingStreets2: boolean;
	loadingIsStep2Eligible: boolean;
	streetsListErr: boolean;

	streetsList: Street[];

	step2Data: Step2Data = new Step2Data();

	isArmyServiceOpened: boolean = false;
	isLastArmyServiceOpened: boolean = false;
    isTavchin2Opened: boolean = false;
    isTavchin5Opened: boolean = false;
    isTavchin12Opened: boolean = false;
    isTavchin13Opened: boolean = false;
    isTavchin14Opened: boolean = false;

    reCaptchaKey: string = this.SiteKeyByUrl();

	highlightErrs: boolean = false;
	isShowErrs(isDataValid: boolean) {
		//debugger;
		//console.log('highlightErrs:' + highlightErrs + ' y:' + yearValid + ' m:' + monthValid + ' d:' + dayValid);
		return this.highlightErrs && !isDataValid;
	}
	highlightErrsSet(isHighlight: boolean) {
		//debugger;
		this.highlightErrs = isHighlight;

		this.step1Clac.isResidentOpened = false;

		this.isArmyServiceOpened = false;
		this.isLastArmyServiceOpened = false;
        this.isTavchin2Opened = false;
        this.isTavchin5Opened = false;
        this.isTavchin12Opened = false;
        this.isTavchin13Opened = false;
        this.isTavchin14Opened = false;
	}
	highlightErrsToggle() {
		//debugger;
		this.highlightErrs = !this.highlightErrs;
	}

	setIsArmyService() {
		this.step2Data.isArmyService = this.step2Data.isArmyServiceSelected ? this.step2Data.isArmyService : null;
		this.isArmyServiceOpened = this.step2Data.isArmyServiceSelected;
	}

	setIsLastArmyService() {
		this.step2Data.isLastArmyService = this.step2Data.isLastArmyServiceSelected ? this.step2Data.isLastArmyService : null;
		this.isLastArmyServiceOpened = this.step2Data.isLastArmyServiceSelected;
	}

	setTavchin2() {
		this.step2Data.isTavchin2 = this.step2Data.isTavchin2Selected ? this.step2Data.isTavchin2 : null;
		this.isTavchin2Opened = this.step2Data.isTavchin2Selected;
    }

    setTavchin5() {
        this.step2Data.isTavchin5 = this.step2Data.isTavchin5Selected ? this.step2Data.isTavchin5 : null;
        this.isTavchin5Opened = this.step2Data.isTavchin5Selected;
    }

    setTavchin12() {
        this.step2Data.isTavchin12 = this.step2Data.isTavchin12Selected ? this.step2Data.isTavchin12 : null;
        this.isTavchin12Opened = this.step2Data.isTavchin12Selected;
    }

    /*
    setTavchin13() {
        this.step2Data.isTavchin13 = this.step2Data.isTavchin13Selected ? this.step2Data.isTavchin13 : null;
        this.isTavchin13Opened = this.step2Data.isTavchin13Selected;
    }
    */

    setTavchin14() {
        this.step2Data.isTavchin14 = this.step2Data.isTavchin14Selected ? this.step2Data.isTavchin14 : null;
        this.isTavchin14Opened = this.step2Data.isTavchin14Selected;
    }

	@ViewChild("cityAutoCompleter") private cityAutoCompleter: AutoCompleterComponent;
	@ViewChild("streetAutoCompleter") private streetAutoCompleter: AutoCompleterComponent;

	ngOnInit() {
		let dataService: CompleterData = this.completerService.local(this.step1Clac.citiesList, 'cityName', 'cityName');
		//this.cityAutoCompleter.setDataService(this.step1Clac.citiesAutoCompleterData);
		this.cityAutoCompleter.setDataService(dataService);
    }

	getStreets4City(city) {
		this.loadingStreets2 = true;
		this.streetsListErr = false;
		this.streetsList = [];
		this._contentService.getStreets4City(city)
			.subscribe(
			streetsList => {
				this.streetsList = [];
				streetsList.forEach((node, ix, nodes) => {
					this.streetsList.push(new Street(
						node.streetID,
						node.streetName
					));
				});

				//this._treeViewComponent.ready()
				this.loadingStreets2 = false;

				let dataService: CompleterData = this.completerService.local(this.streetsList, 'streetName', 'streetName');
				this.streetAutoCompleter.setDataService(dataService);
			},
			error => { this.errorMessage = <any>error; this.loadingStreets2 = false; this.streetsListErr = true;}
			);
	}

	setSelectedCity(city) {
		this.step2Data.selectedWorkCity = city;
		this.step2Data.selectedWorkStreet = -1;
		//alert(city);
		this.getStreets4City(city);
	}

	tryAgainCities() {
		///debugger;
		//alert(2);
		this.loadingStreets2 = this.streetsListErr = this.step1Clac.streetsListErr = false;
		this._contentService.citiesList = [];
		this.step1Clac.getCitiesList();
		this.step2Data.selectedWorkCity = -1;
		this.step2Data.selectedWorkStreet = -1;
		//alert(3);
		return false;
	}

	onSubmit(form: NgForm) {
		//debugger;
		//alert(this.step1Clac.submitted);
		if (this.form == null) {
			this.form = form;
			this.form.valueChanges
				.subscribe(data => {
				this.submitted = false, this.responseReceived = false;
					this.errorMessage = null; this.step1Clac.errorMessage = null;
				});
		}

		this.errorMessage = null;
		this.step1Clac.errorMessage = null;
		if (!this.step1Clac.submitted || !this.step1Clac.responseReceived) {
			this.step1Clac.onSubmit(this.step1Clac.form, this);
			return;
		}
		this.submitted = true;
        this.responseReceived = false;

		this.loadingIsStep2Eligible = true;
		this._contentService.isStep2Eligible(this.step2Data)
			.subscribe(
			result => {
                //alert(result.isStepEligible);

				//this.isStep2Eligible = isEligible;
				this.isStep2Eligible = result.isStepEligible;
				this.isReCaptchaOk = result.isRecaptchaOk;

                this.responseReceived = true;

				//this._treeViewComponent.ready()
				this.loadingIsStep2Eligible = false;
			},
			error => {
			this.errorMessage = <any>error; this.loadingIsStep2Eligible = false; }
			);

	}

	onCitySelected(selected: number) {
		this.setSelectedCity(selected);
	}

	onStreetSelected(selected: number) {
		this.step2Data.selectedWorkStreet = selected;
	}

	public isCaptchaValid: boolean = false;
	public captchaToken: string = null;

	isCaptchaSet(): boolean {
		//debugger;
		let captchaRes: string = null;
		//if (typeof (grecaptcha) == 'undefined' || !grecaptcha)
		//	return false;
		//try {
		//	captchaRes = grecaptcha.getResponse();
		//}
		//catch (err) { console && console.log('isCaptchaSet: ' + err) }

		//console && console.log(captchaRes);

		captchaRes = this.captchaToken;

		this.isCaptchaValid = !!captchaRes;

		return this.isCaptchaValid;
	}

	isCaptchaMissing(): boolean {
		let isMissing: boolean = true;
		try {
			isMissing = typeof (grecaptcha) == 'undefined' || !grecaptcha || //!document.getElementById('g-recaptcha-response-1');
				!document.querySelector('#step2captcha [id^=g-recaptcha-response]');
		}
		catch (err) { console && console.log('isCaptchaMissing: ' + err) }

        this.isCaptchaValid = !isMissing && this.isCaptchaSet();
        if (this.isCaptchaValid)
            this.isReCaptchaOk = true;

		return isMissing;
    }

    /*
    public ngDoCheck(): void {
        this._contentService.detectChanges();
    }
    */

    ngAfterViewInit() {
        ///debugger;
        setTimeout(() => this.isCaptchaMissingProperty = this.isCaptchaMissing(), 0);
        ///this._contentService.detectChanges();
    }

	handleCorrectCaptcha(captchaRes) {
		console && console.log(captchaRes);
		this.step2Data.captchaToken = this.captchaToken = captchaRes;
	}

	handleCaptchaExpired() {
		this.step2Data.captchaToken = this.captchaToken = null;
    }

    SiteKeyByUrl(): string {
        var ReCaptchaSiteKey = "";
        var FireArmsUrl = window.location.host.toLowerCase();
        switch (FireArmsUrl) {

            case "gov.il":
            case "www.gov.il":
                ReCaptchaSiteKey = "6Lc82j0UAAAAAO0aPEp6DK4sdq6IMCtKni6kcTIo";
                break;

            case "test.newgov.gov.il":
                ReCaptchaSiteKey = "6LdVi1IUAAAAABGeZBNTga-jrH4jPt3IG_1oaw8Y";
                break;

            case "localhost:8086":
                ReCaptchaSiteKey = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
                break;

            default:
                break;
        }

        return ReCaptchaSiteKey;
    }

	// TODO: Remove this when we're done
	get diagnostic2() { return JSON.stringify(this.step2Data) ; }

}

declare var grecaptcha: any;




// WEBPACK FOOTER //
// ./src/app/step2-calc/step2-calc.component.ts